export default [
  {
    path: '/',
    name: 'index',
    component: () =>
      import(/* webpackChunkName: "news" */ '@/views/news/index.vue')
  },
  {
    path: '/survey',
    name: '/survey',
    component: () =>
      import(/* webpackChunkName: "news" */ '@/views/news/Survey.vue')
  },
  {
    path: '/surveylist',
    name: '/surveylist',
    component: () =>
      import(/* webpackChunkName: "news" */ '@/views/news/SurveyList.vue')
  },
  {
    path: '/contact',
    name: '/contact',
    component: () =>
      import(/* webpackChunkName: "news" */ '@/views/news/Contact.vue')
  },
  {
    path: '/recruit',
    name: '/recruit',
    component: () =>
      import(/* webpackChunkName: "news" */ '@/views/news/Recruit.vue')
  },
  {
    path: '/membership',
    name: '/membership',
    component: () =>
      import(/* webpackChunkName: "news" */ '@/views/news/Membership.vue')
  },
  {
    path: '/information',
    name: '/information',
    component: () =>
      import(/* webpackChunkName: "news" */ '@/views/news/Information.vue')
  },
  {
    path: '/chapter',
    name: '/chapter',
    component: () =>
      import(/* webpackChunkName: "news" */ '@/views/news/Chapter.vue')
  },
  {
    path: '/detail',
    name: '/detail',
    component: () =>
      import(/* webpackChunkName: "news" */ '@/views/news/Detail.vue')
  }

]
